import React from 'react';

import JWPlayer from './components/JWPlayer';
import CaptionAndCredit from '../display/components/CaptionAndCredit';

import { IVideoAdTargets, EVideoType } from '../types';

export interface IVideoProps {
  externalId: string;
  type: EVideoType;
  adTargets?: IVideoAdTargets;
  caption?: string;
  credit?: string;
  display?: {
    showCaption?: boolean;
  };
}

const Video: React.FC<IVideoProps> = ({
  externalId,
  type,
  adTargets,
  caption,
  credit,
  display: { showCaption = false } = { showCaption: false },
}) => {
  let src = '';

  if (type === EVideoType.Facebook) {
    src = `https://www.facebook.com/plugins/video.php?href=https%3A//www.facebook.com/texastribune/videos/${externalId}`;
  } else if (type === EVideoType.Livestream) {
    src = `https://livestream.com/${externalId}/player`;
  } else if (type === EVideoType.YouTube) {
    src = `https://www.youtube.com/embed/${externalId}`;
  }

  return (
    <figure className="c-image">
      <div className="c-image__placeholder c-image__placeholder--video has-bg-gray-light">
        {type === EVideoType.JWPlayer && (
          <div className="c-image__img did-load">
            <JWPlayer externalId={externalId} adTargets={adTargets} />
          </div>
        )}
        {type !== EVideoType.JWPlayer && (
          <iframe
            className="c-image__img c-image__img--video"
            src={src}
            title="Texas Tribune video"
            scrolling="no"
            frameBorder="0"
            allow="fullscreen"
            allowFullScreen
          />
        )}
      </div>
      {showCaption && (caption || credit) && (
        <CaptionAndCredit credit={credit} caption={caption} />
      )}
    </figure>
  );
};

export default Video;
